import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "../context/AuthContext";

/**
 * ```tsx
 * const auth = useAuth();
 * if (!auth.authenticated) return <LoginPage />;
 * return <App />;
 * ```
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth() must be called within an <AuthProvider>");
  }
  return ctx;
}
